export const DISCOUNT_TYPE_AMOUNT = 'AMOUNT';
export const DISCOUNT_TYPE_PERCENTAGE = 'PERCENTAGE';

export const PACKAGE_TYPE_REGISTRATION = 'REGISTRATION';
export const PACKAGE_TYPE_SOCIAL = 'SOCIAL';